const A_MINUTE = 60 * 1000;

export const TIME = {
  A_MINUTE,
};
